import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Form } from 'antd';
import { Input } from 'ui/styled';
import PhoneInput from 'components/PhoneInput';
import { rules, surveyRules } from '../helpers/formHelpers';
var InputField = function (_a) {
    var _b = _a.id, id = _b === void 0 ? 'default' : _b, _c = _a.inputType, inputType = _c === void 0 ? 'inherit' : _c, placeholder = _a.placeholder, onInputChange = _a.onInputChange, required = _a.required, isTicketSurvey = _a.isTicketSurvey;
    return (_jsx(Form.Item, { name: id, rules: (isTicketSurvey && required) ? surveyRules : rules[inputType], children: inputType === 'phone' ? (_jsx(PhoneInput, { onChange: onInputChange })) : (_jsx(Input, { type: inputType, onChange: function (e) { return onInputChange(e.target.value); }, placeholder: placeholder, "data-test": "InputString_".concat(id) })) }));
};
export default InputField;
